module.exports = __webpack_public_path__ + "static/media/header.3b9e9f8a.png";